import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["enabledCheckbox", "toastCheckbox"]

  connect() {
    console.log('[NotificationPrefs] Connected')
  }

  toggleColumn(event) {
    const column = event.currentTarget.dataset.column
    console.log('[NotificationPrefs] Toggle column:', column)

    const checkboxes = column === "enabled" 
      ? this.enabledCheckboxTargets 
      : this.toastCheckboxTargets

    // Check if all are currently checked
    const allChecked = checkboxes.every(cb => cb.checked)
    
    // Toggle: if all checked, uncheck all; otherwise check all
    checkboxes.forEach(cb => {
      cb.checked = !allChecked
    })
  }
}
